import React from "react";
// Components
import MainTable from '../../Components/Tables/Main/MainTable'
import ButtonSwitchBetweenTables from '../../Components/Buttons/ButtonSwitchBetweenTables'
// Hooks
import { useMaintenanceAlerts } from "../../Hooks/useMaintenanceAlerts";
import { useVehicles } from "../../Hooks/useVehicles";
import { useHistory, useParams } from "react-router-dom";
// Constants
import { alertTypes } from "../../CommonConstants";

const AlertsMaintenance = () => {
    let { vehicleId } = useParams();
    vehicleId = +vehicleId;

    const [alertsData, addAlert, updateAlert, deleteAlert] = useMaintenanceAlerts(vehicleId);

    const history = useHistory();

    const navigateToVehicleDocumentsAndRemindersAlerts = () => history.push(`vehicles/${vehicleId}/alerts/maintenance`)

    const [vehiclesData] = useVehicles(true);
    const vehicle = vehiclesData.find(({ id }) => id === +vehicleId);
    let vehicleName = "";
    if (vehicle) {
        const { brand, model, patent } = vehicle;
        vehicleName = `${brand} ${model} ${patent}`;
    }

    const columns = [
        { title: "Id", field: "id", hidden: true },
        { title: "Tipo", field: "type", lookup: alertTypes.maintenance },
        { title: "Kilómetros entre alertas", field: "kilometersBetween"},
        { title: "Kilómetros de preaviso", field: "kilometersForewarning" },
        { title: "Kilómetros de próxima alerta", field: "kilometersNext", editable: "onAdd" },
    ];

    return (
        <div>
            <ButtonSwitchBetweenTables text={'Ver alertas de documentos y recordatorio'} onClick={navigateToVehicleDocumentsAndRemindersAlerts} />
            <MainTable
                title={`Alertas de mantenimiento de ${vehicleName}`}
                columns={columns}
                data={alertsData}
                requiredFields={["type", "kilometersBetween", "kilometersForewarning", "kilometersNext"]}
                deleteText="Se borrará la alerta"
                onRowAdd={async (newData) => {
                    const dataToSave = { ...newData }
                    delete dataToSave.vehicleId
                    dataToSave.kilometersBetween = +newData.kilometersBetween
                    dataToSave.kilometersForewarning = +newData.kilometersForewarning
                    dataToSave.kilometersNext = +newData.kilometersNext
                    await addAlert(dataToSave)
                }}
                onRowUpdate={async (newData) => {
                    const dataToSave = { ...newData }
                    delete dataToSave.id
                    delete dataToSave.kilometersNext
                    dataToSave.kilometersBetween = +newData.kilometersBetween
                    dataToSave.kilometersForewarning = +newData.kilometersForewarning
                    await updateAlert(dataToSave, newData.id)
                }}
                onRowDelete={async (newData) => await deleteAlert(newData.id)}
            />
        </div>)
}

export default AlertsMaintenance


// WEBPACK FOOTER //
// ./src/Containers/VehicleMaintenanceAlerts/index.js